export const LOGIN_SUCCESSFUL = 'AuthenticationSuccessful'
export const MUST_ACCEPT_TAC = 'AcceptTACRequired'
export const TAC_ACCEPTED = 'TermsAndConditionsAccepted'
export const TWO_FACTOR_REQUIRED_REQUESTED = 'TokenRequested'
export const TWO_FACTOR_REQUIRED_ACCEPTED = 'TokenRequestAccepted'
export const TWO_FACTOR_FAILED = 'AttemptFailed'
export const TOKEN_EXPIRED = 'TokenExpired'
export const EXCEEDED_ATTEMPTS = 'ExceededAttempts'
export const PASSWORD_CHANGE_REQUIRED = 'PasswordChangeRequired'
export const PASSWORD_CHANGED = 'PasswordChanged'
export const PASSWORD_CHANGE_FAILED = 'IncorrectPassword'
// PASSWORD_UPDATE appears to come back instead of PASSWORD_CHANGE when you updated someone elses password from User Management
export const PASSWORD_UPDATED = 'PasswordUpdated'
export const TOKEN_VERIFIED = 'TokenVerified'
export const REQUEST_RECEIVED = 'RequestReceived'
export const MEMBER_ADD_SUCCESSFUL = 'MemberAddSuccessful'
export const PASSWORD_UPDATE_FAILED = 'PasswordUpdateFailed'
export const MEMBER_UPDATE_SUCCESSFUL = 'MemberUpdateSuccessful'
export const NO_RECORD_FOUND = 'NoRecordFound'
export const MAINTENANCE_MODE = 'MaintenanceMode'
